import { mulberry32 } from '../math/rng';

/**
 * How much rock lies between two worlds joined by a cave (between their sea-level walls),
 * so how long the cave is. Bigger worlds sit further apart. It goes by the geometric mean
 * of the radii, so a big world next to a small one gets a medium cave. The seed shifts it
 * by ±15%: a pattern, not a rule.
 * - Verdant and Glowmire: about 400–540 m.
 * - A pair of 300 m geodes: about 90–110 m.
 */
/** The shortest cave (m of rock): room for both entrances' stairs and a cave between their gates. */
export const MIN_GAP = 90;

export function caveGap(ra: number, rb: number, seed: number, minGap = 0): number {
  const mean = Math.sqrt(ra * rb);
  const base = 170 * Math.sqrt(mean / 1000);
  const u = mulberry32(seed)();
  const gap = Math.min(Math.max(base * (0.85 + 0.3 * u), MIN_GAP), 1200);
  return Math.max(gap, minGap);
}
